module.exports = __webpack_public_path__ + "img/upload_bg_11.14218a09.png";